import { createFileRoute } from '@tanstack/react-router';
import { TaskListPage } from '@/components/organisms/contacts/ContactTasksPage';

function TasksWorkspacePage() {
  return <TaskListPage mode="workspace" />;
}

export const Route = createFileRoute('/_dashboard/dashboard/tasks')({
  component: TasksWorkspacePage,
});
